import { SkeletonLoader } from '@core/Components/Loading/SkeletonLoader';
import { Typography } from '@gds/Typography/Typography';

import styles from './OfferModal.module.css';

export const OfferLayoutSkeleton = () => {
  return (
    <div className={styles.campaignLayoutWrapper}>
      <Typography variant="subheading1" className={styles.title}>
        <SkeletonLoader width={'100%'} height={40} />
      </Typography>
    </div>
  );
};
